// ======================= Imports =======================
import React from "react";
import { ProgressSpinner } from "primereact/progressspinner";

// ======================= Custom Loading Component =======================
export default function CustomLoading() {
  return (
    <div className="text-center">
      <ProgressSpinner />
    </div>
  );
}
